import { render } from "./LegacyRoomConditionReportSettings.vue?vue&type=template&id=5fca5db5"
import script from "./LegacyRoomConditionReportSettings.vue?vue&type=script&lang=js"
export * from "./LegacyRoomConditionReportSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__